/**
 * Retrieves the number of points the user would earn with the partnership for the package
 * @param partnership The partnership to get the points for
 * @param basePrice The base price (pre-surcharges) of the pkg being purchased
 */
export function getRewardPoints(partnership: App.PackagePartnership, basePrice: number) {
  return Math.floor((partnership.localRewardConversionRate * basePrice) + partnership.bonusPoints)
}
